import { IShortenerController } from '../domain/ShortenerController'

export default class ShortenerUseCases {
  static async shortenUrl (controller: IShortenerController, url: string): Promise<string> {
    return await controller.shortenUrl(url)
  }
}
